import { render, staticRenderFns } from "./newsView.vue?vue&type=template&id=5084eb9a&scoped=true"
import script from "./newsView.vue?vue&type=script&lang=js"
export * from "./newsView.vue?vue&type=script&lang=js"
import style0 from "./newsView.vue?vue&type=style&index=0&id=5084eb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5084eb9a",
  null
  
)

export default component.exports